import L from "leaflet";
import { Marker } from "react-leaflet";
import { Rasteplass } from "../../../services/RuteplanAPI";
import rasteplassIconResource from "../../../assets/restingarea.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const rasteplassIcon = L.icon({
    iconUrl: rasteplassIconResource,
    iconRetinaUrl: rasteplassIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IRasteplassMarkersProps {
    rasteplasser: Array<Rasteplass>;
}

export default function RasteplassMarkers (props: IRasteplassMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const { rasteplasser } = props;

    return (
        <>
            {rasteplasser.map((rasteplass: Rasteplass, index: number) => {
                return (
                    <Marker key={rasteplass.navn + index} 
                    position={[rasteplass.location!.y, rasteplass.location!.x]} 
                    icon={rasteplassIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(rasteplass);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}